function initCards() {
  document.querySelectorAll('.hf-card').forEach(card => {
    const ctl       = card.querySelector('.corner--tl');
    const ctr       = card.querySelector('.corner--tr');
    const cbl       = card.querySelector('.corner--bl');
    const cbr       = card.querySelector('.corner--br');
    const recTag    = card.querySelector('.card__rec-tag');
    const msCounter = card.querySelector('.card__ms-counter');
    const video     = card.querySelector('.hf-card-video');
    const drawLabel = card.querySelector('.card__draw-label');

    if (!ctl) return;

    if (video) {
        video.addEventListener('ended', () => {
            ms = 0;
            if (msCounter) msCounter.textContent = formatMs(0);
        });
    }

    let timerInterval = null;
    let ms = 0;


    function formatMs(n) {
      return String(n).padStart(5, '0');
    }

    function updateHud() {
      ms += 37;
      if (msCounter) msCounter.textContent = formatMs(ms);
    }

    function onEnter() {
        const mediaEl = card.querySelector('.hf-card-image');

        if (ctl) ctl.style.opacity = '1';
        if (ctr) ctr.style.opacity = '1';
        setTimeout(() => {
            if (cbl) cbl.style.opacity = '1';
            if (cbr) cbr.style.opacity = '1';
        }, 40);

        if (recTag) recTag.classList.add('is-active');

        ms = 0;
        if (msCounter) {
            msCounter.textContent = formatMs(0);
            msCounter.style.opacity = '1';
            timerInterval = setInterval(updateHud, 37);
        }

        if (drawLabel) drawLabel.style.opacity = '1';

        if (mediaEl) {
            mediaEl.classList.remove('is-glitching');
            void mediaEl.offsetWidth;
            mediaEl.classList.add('is-glitching');
            setTimeout(() => mediaEl.classList.remove('is-glitching'), 450);
        }

        if (video) {
            if (video.readyState === 0) video.load();
            const play = () => {
                video.currentTime = 0;
                video.play().catch(() => {});
            };

            video.addEventListener('playing', () => {
                //video.style.transition = 'none';
                video.style.opacity = '1';
                }, { once: true });
                video.readyState >= 3 ? play() : video.addEventListener('canplay', play, { once: true });
            }
        }

    function onLeave() {
      [ctl, ctr, cbl, cbr].forEach(c => { if (c) c.style.opacity = '0'; });

      if (recTag) recTag.classList.remove('is-active');
      if (drawLabel) drawLabel.style.opacity = '0';

      if (timerInterval) { clearInterval(timerInterval); timerInterval = null; }
      if (msCounter) msCounter.style.opacity = '0';

      if (video) {
        video.pause();
        video.currentTime = 0;
        video.style.opacity = '0';
      }
    }

    card.addEventListener('mouseenter', onEnter);
    card.addEventListener('mouseleave', onLeave);
  });
}

function initDrawers() {
  document.querySelectorAll('holster-drawer').forEach(drawer => {
    drawer.addEventListener('drawer-open', () => {
      const video = drawer._body?.querySelector('video');
      if (!video) return;
      if (video.readyState === 0) video.load();
      const tryPlay = () => { video.currentTime = 0; video.play().catch(() => {}); };
      video.readyState >= 3 ? tryPlay() : video.addEventListener('canplay', tryPlay, { once: true });
    });

    drawer.addEventListener('drawer-close', () => {
      const video = drawer._body?.querySelector('video');
      if (!video) return;
      video.pause();
      video.currentTime = 0;
    });
  });
}

function bootstrap() {
  const hf = document.querySelector("holster-finder");
  if (hf) {
    hf.addEventListener("holster-finder:ready", () => {
      initCards();
    });
  }
  initDrawers();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}